<template>
  <div>
    <div class="settings-stage">
      <div class="row">
        <!-- Title -->
        <div class="stage-title">Ustawienia</div>
        <hr />
      </div>
      <div class="row">
        <OrdersManagerSettingsList />
      </div>
    </div>
  </div>
</template>

<script>
import OrdersManagerSettingsList from "./OrdersManagerSettingsList";

export default {
  name: "OrdersManagerSettings",
  components: {
    OrdersManagerSettingsList,
  },
  computed: {
  },
  data() {
    return {
      elementsEnabled: true,
      opacityStyle: "opacity:1;",
    };
  },
  methods: {},
  watch: {
  },
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
  },
};
</script>

<style scoped>
.settings-stage {
  padding-left: 16px;
  padding-right: 16px;
}
</style>
